<template>
    <div>
        <div class="loading-spinner-outer" v-if="saving">
            <div class="loading-spinner-inner">
                <div class="loading-spinner"></div>
                <div class="loading-spinner-content">
                    Saving, please wait
                </div>
            </div>
        </div>
        <div class="box">
            <div class="box-content">
                <form method="POST" action="/add-customer" id="create_customer_form">
                    <input type="hidden" name="_token" v-model="csrfToken">
                  <div class="flex-xs">
                    <div class="half-width-xs pr-10-xs">
                            <div class="form-group">
                                <label>Name</label>
                                <input type="text" name="name" v-model="user.name" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Phone Number</label>
                                <input type="text" name="phone" v-model="user.phone" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label>Email Address</label>
                                <input type="text" name="email" v-model="user.email" class="form-control" required>
                            </div>
                            <div class="form-group" v-if="logged_in_user.isAdmin">
                              <label>Login Type</label>
                              <select class="form-control" name="auth_type_id" v-model="user.auth_type_id">
<!--                                <option value="1">Password Only</option>-->
                                <option value="2">MFA - Email Code</option>
                                <option value="3">Azure Login</option>
                              </select>
                            </div>
                        <div class="form-group" v-if="from_section === 'companies'">
                            <label>Lead Recipient</label>
                            <div class="radios _inline">
                                <label class="radio">
                                    <input type="radio" v-model="user.lead_recipient" name="lead_recipient" :value="1" :disabled="!user_can_be_lead_recipient">
                                    <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio">
                                    <input type="radio" v-model="user.lead_recipient" name="lead_recipient" :value="0">
                                    <span class="radio-label">No</span>
                                </label>
                            </div>
                            <div class="mt-2 txt-sm txt-danger" v-if="!user_can_be_lead_recipient">
                                Company has maximum of 3 lead recipients.
                            </div>
                        </div>
                            <div class="form-group">
                              <label>Temporary Login</label>
                              <div class="radios _inline">
                                <label class="radio">
                                  <input type="radio" v-model="user.temporary_login" name="temporary_login" :value="1">
                                  <span class="radio-label">Yes</span>
                                </label>
                                <label class="radio">
                                  <input type="radio" v-model="user.temporary_login" name="temporary_login" :value="0">
                                  <span class="radio-label">No</span>
                                </label>
                              </div>
                            </div>
                            <div class="form-group" v-if="user.temporary_login">
                              <label>Temporary Login Expiration Date</label>
                              <datepicker input-class="form-control" v-model="user.temporary_login_expires_at" name="temporary_login_expires_at"></datepicker>
                            </div>
                        </div>
                    </div>
                  <template v-if="from_section === 'companies'">
                    <input type="hidden" name="company_id" v-model="user.company_id">
                  </template>
                  <template v-if="from_section === 'customers'">
                    <hr class="mb-6 mt-6">
                    <div class="flex-xs mb-6">
                      <div>
                        <h3 class="txt-primary pr-3-xs">
                          Select which company this user belongs to:
                        </h3>
                      </div>
                      <div class="flex-2xs justify-end ml-a">
                        <div class="flex justify-end ml-a mb-1 mb-0-2xs">
                        <div class="pr-1">
                          <a class="btn-primary" @click.prevent="refreshCompanies()">
                            <i class="fal fa-sync"></i>
                          </a>
                        </div>
                        <div class="pr-1-2xs">
                          <a class="btn-primary" href="/company/create" target="_blank">
                            Add New
                          </a>
                        </div>
                        </div>
                        <div class="pr-1-2xs mb-1 mb-0-2xs">
                          <div class="multi-select-input" @click.stop="filter_dropdown_open = !filter_dropdown_open" style="min-width:165px;">
                            <div class="multi-select-input-placeholder">
                              Filter...
                              <div class="dropdown-icon">
                                <i class="fal fa-chevron-down"></i>
                              </div>
                            </div>
                            <div class="multi-select-input-inner" v-show="filter_dropdown_open">
                              <div class="multi-select-input-group">
                                <h1 class="input-group-title">Company Types</h1>
                                <div class="checkboxes">
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="1" v-model="selected_company_types">
                                      <span class="checkbox-label">Fabricator</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="2" v-model="selected_company_types">
                                      <span class="checkbox-label">Installer</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="3" v-model="selected_company_types">
                                      <span class="checkbox-label">Trade Counter</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="4" v-model="selected_company_types">
                                      <span class="checkbox-label">Other</span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                              <div class="multi-select-input-group mt-3">
                                <h1 class="input-group-title">System Types</h1>
                                <div class="checkboxes">
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="1" v-model="selected_system_types">
                                      <span class="checkbox-label">Stellar</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="2" v-model="selected_system_types">
                                      <span class="checkbox-label">Profile22</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="3" v-model="selected_system_types">
                                      <span class="checkbox-label">Swish</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="4" v-model="selected_system_types">
                                      <span class="checkbox-label">PatioMaster</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="5" v-model="selected_system_types">
                                      <span class="checkbox-label">Spectus</span>
                                    </label>
                                  </div>
                                  <div class="checkbox level-1">
                                    <label>
                                      <input type="checkbox" name="systems" :value="6" v-model="selected_system_types">
                                      <span class="checkbox-label">Safeware</span>
                                    </label>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div>
                          <input type="text" placeholder="Search" class="form-control" v-model="companies_search_query">
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="relative">
                        <div style="position: absolute; top:0; left:0; right: 0; bottom: 0; background:white; opacity: 0.8;" v-show="filtering"></div>
                      <table class="table _lined">
                        <tbody>
                        <tr v-for="(company, index) in companies">
                          <td style="width: 40px;">
                            <input type="radio" name="company_id" v-model="user.company_id" :value="company.id" :id="`company_${company.id}`">
                          </td>
                          <td style="width: 125px;">
                            <label :for="`company_${company.id}`">
                              {{ company.account_code }}
                            </label>
                          </td>
                          <td>
                            <label :for="`company_${company.id}`">
                              {{ company.name }}
                            </label>
                          </td>
                          <td class="align-right" style="width: 40px;">
                            <a :href='"/company/"+company.id' class="txt-primary pl-3" target="_blank">
                              <i class="fa fa-eye"></i>
                            </a>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                      </div>
                      <template>
                        <div class="pagination-bar wrapper mb-3 mt-3">
                          <div class="row">
                            <div class="col">
                              <a @click.prevent="prevCompaniesPage()" v-if="current_companies_page > 1" class="btn-default _sm"><i
                                  class="fa fa-caret-left"></i></a>
                              <a class="btn-default _sm">{{ current_companies_page }} / {{ total_companies_pages }}</a>
                              <a @click.prevent="nextCompaniesPage()" v-if="current_companies_page < total_companies_pages"
                                 class="btn-default _sm"><i class="fa fa-caret-right"></i></a>
                            </div>
                            <div class="col align-right">
                              <div class="mt-1 mb-1">
                                {{ total_companies_count }} results found
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                    <hr class="mb-6 mt-6">
                  </template>
                    <div class="align-right mt-3">
                        <button type="submit" class="btn-primary" @click.stop.prevent="save()">
                            Create User
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>

  import vue2Dropzone from 'vue2-dropzone';
  import Datepicker from "vuejs-datepicker";

  export default {
    props: [
      'logged_in_user',
      'from_section',
      'company_id',
      'user_can_be_lead_recipient',
    ],
    components: {
      'vue-dropzone': vue2Dropzone,
      'datepicker': Datepicker,
    },
    mounted() {
      if(this.from_section === 'customers') {
        this.loadCompanies();
      }
      if(this.from_section === 'companies') {
        this.user.company_id = this.company_id;
      }
    },
    data() {
      return {
        csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        user: {
          auth_type_id: 2,
          temporary_login: 0,
          lead_recipient: 0,
          temporary_login_expires_at: null,
        },
        companies: [],
        current_companies_page: 1,
        companies_search_query: '',
        companies_limit: 5,
        total_companies_count: 0,
        total_companies_pages: 0,
        saving: false,
        filter_dropdown_open: false,
        filtering: false,
        selected_company_types: [],
        selected_system_types: [],
      }
    },
    methods: {
      loadCompanies: _.debounce(function() {
        axios.post('/company/loadCompanies', {
          page_number: this.current_companies_page,
          search_query: this.companies_search_query,
          search_on: 'company_name',
          selected_company_types: this.selected_company_types,
          selected_system_types: this.selected_system_types,
          limit: this.companies_limit,
        }).then((response) => {
          this.companies = response.data.data;
          this.total_companies_count = response.data.total;
          this.total_companies_pages = response.data.last_page;
          this.filtering = false;
        });
      }, 250),
      refreshCompanies() {
        this.companies_search_query = '';
        this.current_companies_page = 1;
        this.loadCompanies();
      },
      prevCompaniesPage() {
        this.current_companies_page = this.current_companies_page - 1;
        this.loadCompanies();
      },
      nextCompaniesPage() {
        this.current_companies_page = this.current_companies_page + 1;
        this.loadCompanies();
      },
      save() {
        this.saving = true;
        const validationErrors = Validate({
          'Company': this.user.company_id,
          'Name': this.user.name,
          'Phone': this.user.phone,
          'Email': this.user.email,
        }, {
          'Company': {
            presence: {
              allowEmpty: false,
            },
          },
          'Name': {
            presence: {
              allowEmpty: false,
            },
          },
          'Phone': {
            presence: {
              allowEmpty: false,
            },
          },
          'Email': {
            presence: {
              allowEmpty: false,
            },
            email: true,
          },
        });

        if (validationErrors) {
          this.saving = false;
          Swal.fire({
            title: 'Unable to create user',
            icon: 'error',
            html: `<div class="mb-3">${Object.values(validationErrors).join('</div><div class="mb-3">')}</div>`,
          });
          return;
        }

        document.getElementById('create_customer_form').submit();

      },
    },
    watch: {
      companies_search_query() {
        this.filtering = true;
        this.current_companies_page = 1;
        this.loadCompanies();
      },
      selected_company_types() {
        this.filtering = true;
        this.current_page = 1;
        this.loadCompanies();
      },
      selected_system_types() {
        this.filtering = true;
        this.current_page = 1;
        this.loadCompanies();
      },
      'user.temporary_login'() {
        if(this.user.temporary_login_expires_at === null) {
          let date = new Date();
          date.setMonth(date.getMonth() + 1)
          this.user.temporary_login_expires_at = date;
        }
      },
    },
  };
</script>
